import { FormattedMessage } from "react-intl";
import { UserStatus } from "../../../../../models/users.interface";
import DateTime from "../../../../Shared/DateTime/DateTime";
import NoDataIndicator from "../../../../Shared/NoDataIndicator/NoDataIndicator";
import ToggleUserActiveButton from "../../../EditUser/ToggleUserActiveButton/ToggleUserActiveButton";
import UserCreatedActivatedDates from "../../../UserCreatedActivatedDates/UserCreatedActivatedDates";
import styles from "./PatientGeneralDetailsHeader.module.css";

type PatientGeneralDetailsHeaderProps = {
  createdAt?: string;
  activatedAt?: string;
  totalEcgs?: number;
  lastEcgDate?: string;
  deviceSn?: string;
  userStatus?: UserStatus;
  loading?: boolean;
  onToggleUserActive?: (isActive: boolean) => void;
};

const PatientGeneralDetailsHeader = ({
  createdAt,
  activatedAt,
  totalEcgs,
  lastEcgDate,
  deviceSn,
  userStatus,
  loading,
  onToggleUserActive,
}: PatientGeneralDetailsHeaderProps) => {
  const isUserPending = userStatus === "pending";
  const isUserActive = userStatus === "active";

  const toggleUserActiveHandler = () => {
    if (onToggleUserActive) onToggleUserActive(!isUserActive);
  };

  return (
    <header className={`${styles.header} container`}>
      <div className="row d-flex flex-column py-2 px-3 mt-2">
        <UserCreatedActivatedDates
          activatedAt={activatedAt}
          createdAt={createdAt}
          isUserPending={isUserPending}
          dateClassName={styles.date}
          className="flex-grow-1"
        />
      </div>
      <div className="d-flex align-items-center pb-2 px-3 row">
        <div className="w-50 py-1">
          <span>
            <FormattedMessage
              id="PATIENT.NO_OF_ECGS"
              defaultMessage="# of ECGs"
            />
            :
          </span>
          <span className="mx-sm"></span>
          {!totalEcgs && totalEcgs !== 0 ? (
            <NoDataIndicator />
          ) : (
            <span className={styles.totalEcgs}>
              <b>{totalEcgs}</b>
            </span>
          )}
        </div>
        <div className="w-50">
          <span>
            <FormattedMessage
              id="PATIENT.LAST_ECG_DATE"
              defaultMessage="Last ECG date"
            />
            :
          </span>
          <span className="mx-sm"></span>
          <span>
            <DateTime>{lastEcgDate}</DateTime>
          </span>
        </div>
        <div className="w-100 d-flex align-items-center">
          <div className=" w-50">
            <span>
              <FormattedMessage
                id="SMARTHEART_SN"
                defaultMessage="Smartheart S/N"
              />
              :
            </span>
            <span className="mx-sm"></span>
            <span>{deviceSn ? deviceSn : <NoDataIndicator />}</span>
          </div>
          <div className="w-50">
            <ToggleUserActiveButton
              disabled={loading}
              onClick={isUserPending ? undefined : toggleUserActiveHandler}
              isUserActive={isUserActive}
              visible={!isUserPending}
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default PatientGeneralDetailsHeader;
